import React from "react";
import "../styles/styles.css";

function ServicesPage() {
  const services = [
    {
      title: "Web Development",
      description:
        "Create modern, responsive, and scalable web applications tailored to your needs.",
      icon: "🌐",
    },
    {
      title: "Graphic Design",
      description:
        "Crafting visually stunning designs for your brand identity, marketing materials, and more.",
      icon: "🎨",
    },
    {
      title: "SEO Optimization",
      description:
        "Boost your website's visibility with cutting-edge SEO techniques.",
      icon: "📈",
    },
    {
      title: "Digital Marketing",
      description:
        "Reach your audience effectively with strategic marketing campaigns.",
      icon: "💻",
    },
    {
      title: "Mobile App Development",
      description:
        "Develop robust and user-friendly mobile applications for Android and iOS.",
      icon: "📱",
    },
    {
      title: "Customer Support",
      description:
        "Provide top-notch customer support solutions tailored to your business.",
      icon: "🤝",
    },
  ];

  return (
    <div className="services-page">
      <h1 className="services-title">Our Services</h1>
      <div className="services-container">
        {services.map((service, index) => (
          <div className="service-card" key={index}>
            <div className="service-icon">{service.icon}</div>
            <h2 className="service-title">{service.title}</h2>
            <p className="service-description">{service.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ServicesPage;
